module.exports = __webpack_public_path__ + "static/img/service-5.cc4c019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/service-5.png
// module id = c8Ea
// module chunks = 1